import { render, staticRenderFns } from "./carousel-pages-block.vue?vue&type=template&id=409581f4&"
import script from "./carousel-pages-block.vue?vue&type=script&lang=js&"
export * from "./carousel-pages-block.vue?vue&type=script&lang=js&"
import style0 from "./carousel-pages-block.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
